import React from 'react';

export default function NotFound() {
  return (
    <div className="not-found-msg pt-5">
        <h1>404</h1>
        <h2 className="pl-4">Page Not Found</h2>
        <p>If difficulties persist, please contact the System Administrator of this site and report the error.</p>
    </div>
  );
}
